<template>
    <div class="student">
        <h1>STUDENT BENEFITS</h1>
        <PageHeader :value="data"></PageHeader>
        <br>
    </div>
</template>
<script lang="ts" setup>
    import { ref, reactive } from 'vue'
    import PageHeader from '@/components/wap/PageHeader-wap.vue';

    const paragraph = [
      {
        title:'GEP assists students who would like to study outside their countries',
        data:'GEP offers the following services<br><br>&nbsp&nbsp&nbsp1.&nbsp&nbsp&nbspAssess your qualifications and eligibility based on the country that you have chosen.<br>&nbsp&nbsp&nbsp2.&nbsp&nbsp&nbspPrepare you for the college or university requirements including English<br>&nbsp&nbsp&nbsp3.&nbsp&nbsp&nbspOrganise college or university that has you chosen qualification.<br>&nbsp&nbsp&nbsp4.&nbsp&nbsp&nbspPlan a pathway should you choose to stay in the country after your studies (only applies to International Students who choose Australia)<br>&nbsp&nbsp&nbsp5.&nbsp&nbsp&nbspPrepare itemised quote of all requirements<br><br>GEP works with MARA Registered Agent for your Visa Applications</p>'
      }
    ];

    const data = reactive(
      {
        paragraph:paragraph,
        rootPath:'/education-wap',
        root:'Education',
        current:'student benefit',
        currentPath:'/student-wap',
        inquiryPath:'/contact-wap',
        isPara:true,
        isTable:false
      }
    );

</script>

<style scoped>
  h1 {
    font-size: 2rem;
    font-weight: 400;
  }
</style>